import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Introduction from './Introduction/index';
import Projects from './Projects/index';
import Credentials from './Credentials/index';
import Skills from './Skills/index';
import Experiences from './Experiences/index';
import Footer from "./Footer/footer";
import Navigation from "./Navigation/navigation";
import PageNotFound from "./common/PgNF/pagenotfound";

function App() {
  return (
    <div className="App">
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path="/" element={<Introduction />} exact />
                <Route path="/experience" element={<Experiences />} exact />
                <Route path="/projects" element={<Projects />} exact/>
                <Route path="/credentials" element={<Credentials />} exact/>
                <Route path="/skills" element={<Skills />} exact/>
                <Route path="*" element={<PageNotFound />} default/>
            </Routes>
            <Footer />
            <Navigation />
        </BrowserRouter>
    </div>
  );
}

export default App;
